const PageSettings = new function() {
  this.groupLayerSettings = [];
  //Map center and zoom history
  this.latestMapSettings = [];

  this.saveGroupLayerSettings = function(groupId, layerId, active) {
  	var settings = {id: groupId, layerId: layerId, active: active};
  	//console.log(groupId, layerId, active);
  	for(var i in this.groupLayerSettings) {
  		if(this.groupLayerSettings[i].id == groupId && this.groupLayerSettings[i].layerId == layerId) {
  			this.groupLayerSettings.splice(i, 1);
  		}
  	}
  	this.groupLayerSettings.push(settings);
  	//console.log(this.groupLayerSettings);
  };

  this.saveMapSettings = function(map, type, id) {
  	var zoom = map.map.getZoom();
  	var center = map.map.getCenter();
  	var settings = {type: type, id: id, zoom: zoom, center: center};
  	//var alreadyExists = _.find(app.latestMapSettings, function(obj) { return obj.id == id && obj.type == type});
  	//console.log(alreadyExists);
  	for(var i in this.latestMapSettings) {
  		if(this.latestMapSettings[i].type == type && this.latestMapSettings[i].id == id) {
  			this.latestMapSettings.splice(i, 1);
  		}
  	}
  	this.latestMapSettings.push(settings);
  };

  this.getMapSettings = function(type, tagId) {
    var setting = this.latestMapSettings.find(obj => obj.id == tagId && obj.type == type);
  	return (setting == undefined) ? false : setting;
  };
};

export default PageSettings;
